export const payoutStateAllowedTestCaseMap = {
  completed: ['returned'],
  processing: ['success', 'returned']
} as const;

type AllowedTestCases = typeof payoutStateAllowedTestCaseMap;

export type AllowedTestCase = AllowedTestCases[keyof AllowedTestCases][number];
